import unwrapList from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/unwrapList'
import type {
  GosPhoneDepartment,
  GosPhoneSpeciality,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPhonebook/types'

type RawGosPhoneDepartment = {
  name?: string
  specialities?: GosPhoneSpeciality[] | Record<string, GosPhoneSpeciality>
}

/**
 * Отделы телефонного справочника из SSR-контекста.
 *
 * Django может отдать `gos_phones` и `specialities` объектом с числовыми ключами.
 */
export default function unwrapGosPhones(value: unknown): GosPhoneDepartment[] {
  return unwrapList<RawGosPhoneDepartment>(value as RawGosPhoneDepartment[] | Record<string, RawGosPhoneDepartment>)
    .map(department => ({
      name: department.name,
      specialities: unwrapList(department.specialities),
    }))
    .filter(department => department.specialities.length)
}
